<template>
  <v-card>
    <v-card-title>
      <span class="headline">Time Picker</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="actionHandler(dataType.DialogActionEnum.HIDE)">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      Please select the time range you want to query.
      <v-layout>
        <v-flex lg6>
          <arb-date-picker-menu label="Start Date" v-model="dateRange.startDate"></arb-date-picker-menu>
        </v-flex>
        <v-flex lg6>
          <arb-date-picker-menu label="End Date" v-model="dateRange.endDate"></arb-date-picker-menu>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="actionHandler(dataType.DialogActionEnum.OPERATE)">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { Tool, DataType } from '@/util/index'
const tool = new Tool()
export default {
  name: 'arb-date-range-card',
  props: {
    value: {
      type: Object,
      required: true
    },
    eventHandler: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      dateRange: {},
      dataType: DataType
    }
  },
  watch: {
    value (val) {
      this.dateRange = val
    }
  },
  methods: {
    actionHandler (event) {
      switch (event) {
        case DataType.DialogActionEnum.HIDE:
          this.eventHandler(DataType.DialogActionEnum.HIDE)
          break
        case DataType.DialogActionEnum.OPERATE:
          switch (this.validateDateRange()) {
            case 'all':
              this.dateRange.endDate = ''
              this.dateRange.startDate = ''
              this.$emit('input', this.dateRange)
              this.$emit('showDateRange', this.dateRange)
              this.eventHandler(DataType.DialogActionEnum.OPERATE)
              break
            case 'range':
              this.$emit('input', this.dateRange)
              this.$emit('showDateRange', this.dateRange)
              this.eventHandler(DataType.DialogActionEnum.OPERATE)
              break
            case 'error':
              this.$popWarningAlert({ text: 'Input completely and Start Date must less than End Date !' })
              break
            default:
              break
          }
          break
        default:
          break
      }
    },
    validateDateRange () {
      const startDate = this.dateRange.startDate
      const endDate = this.dateRange.endDate
      if (!tool.isNotEmpty(startDate) && !tool.isNotEmpty(endDate)) {
        return 'all'
      }
      if (tool.isNotEmpty(startDate) && tool.isNotEmpty(endDate)) {
        if (startDate <= endDate) {
          return 'range'
        } else {
          return 'error'
        }
      }
    }
  }
}
</script>
